/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  GetChainReportsSummaryQueryResponse,
  GetChainReportsSummaryQueryParams,
} from '../types/GetChainReportsSummary'

function getGetChainReportsSummaryUrl() {
  const res = { method: 'GET', url: `/api/v1/reports/chains/summary/` as const }
  return res
}

/**
 * @description Aggregate summary (count, places_count, avg_chain_count, total_ltv, avg_total_ltv, avg_revenue_ltv, avg_pounds_per_year) for the chain reports matching the same filters as listChainReports, returned as a single object rather than a paginated list.
 * @summary Chain reports aggregate summary
 * {@link /api/v1/reports/chains/summary/}
 */
export async function getChainReportsSummary(
  params?: GetChainReportsSummaryQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetChainReportsSummaryQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getGetChainReportsSummaryUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
